<template>
  <div>

    <validation-observer ref="form">
      <b-form @submit.prevent="save">
        <!--
        <div class="vx-row">
          <div class="vx-col w-full">
            <b-input-group>
              <b-form-input v-model="teacher.name" readonly/>
              <b-input-group-append>
                <b-button variant="outline-primary" @click="showTeacherPopupSearch = true">
                  <feather-icon
                    icon="SearchIcon"
                    class="mr-50"/>
                  <span class="align-middle">Buscar</span>
                </b-button>
                <b-button variant="outline-primary" @click="showTeacherPopupIncludeForm = true">
                  <feather-icon
                    icon="PlusIcon"
                    class="mr-50"/>
                  <span class="align-middle">Incluir</span>
                </b-button>
                <b-button variant="outline-primary" @click="clearFields()">
                  <feather-icon
                    icon="XIcon"
                    class="mr-50"/>
                  <span class="align-middle">Limpar</span>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
        </div>
        -->
        <div class="w-full flex gap-2 justify-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              @click="showTeacherPopupSearch = true"
              class="float-right">
              <feather-icon
                    icon="SearchIcon"
                    class="mr-50"/>
              <span class="align-middle">Buscar</span>
            </b-button>
            <!--
            <b-button variant="outline-primary" @click="showTeacherPopupInclude = true" class="float-right mr-2">
              <feather-icon
                icon="PlusIcon"
                class="mr-50"/>
              <span class="align-middle">Incluir</span>
            </b-button>
            -->
        </div>
      </b-form>
    </validation-observer>

    <teacher-popup
            :visible="showTeacherPopupSearch"
            @selected="addTeachersList"
            @close="closePopup"
            :filters="filtersGridTeacher"/>

    <div class="vx-row mt-4 mb-10">
      <div class="vx-col w-full">
        <vs-table :data="teachersList" no-data-text="Nenhum registro encontrado">
          <template slot="thead">
            <vs-th>Nome</vs-th>
            <vs-th>E-mail</vs-th>
            <vs-th>Ação</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{data[indextr].name}}</vs-td>
              <vs-td>{{data[indextr].email}}</vs-td>
              <vs-td>
                <div class="flex flex-row gap-2">
                  <feather-icon
                    icon="Trash2Icon"
                    style="cursor: pointer;"
                    class="h-5 w-5 mr-1 stroke-current text-danger"
                    @click="destroy(data[indextr])"/>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BForm, BButton, BFormInput, BFormGroup, BFormCheckbox, BInputGroupAppend, BInputGroup
} from 'bootstrap-vue'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

import TeacherPopup from './../people/teacher/TeacherPopup.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    vSelect,
    // BSV
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BFormCheckbox,
    BInputGroupAppend,
    BInputGroup,
    // validations
    ValidationProvider,
    ValidationObserver,
    //
    TeacherPopup
  },
  props: {
    services: {
      type: Object,
      default: null
    },
    lessonId: {
      type: Number,
      default: null
    },
  },
  data: () => ({
    id: null,
    showTeacherPopupSearch: false,
    showTeacherPopupInclude: false,
    teacher: {
      document: null,
      name: null,
      email: null,
    },
    teachersList: [],
    editMode: false,
    // validation rules
    required,
  }),
  computed: {
    validateForm() {
      return (
        // !this.errors.any() && //vee-validate-fix
        !this.isEmpty(this.teacher.name) &&
        !this.isEmpty(this.teacher.email)
      )
    }
  },
  watch: {},
  methods: {
    save() {

      this.$refs.form.validate().then(success => {
        if (success) {

          this.clearErrors(this.$refs.form)
          this.$vs.loading()

          const params = {
            people_id: this.people_id,
            name: this.teacher.name,
            email: this.teacher.email,
          }

          if (this.editMode) {
            params['lessonId'] = this.id
          }

          this.services.attachTeachers(this.id, params).then(
            data => {
              this.$vs.loading.close()
              this.loadData()
              this.editMode = false
              this.clearFields()
              this.notifySuccess(this.$vs)
            },
            error => {
              this.$vs.loading.close()
              this.showErrors(this.$refs.form, error)
            }
          )
        }
      })
    },
    destroy(entity) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja excluir este registro?',
        accept: () => {
          this.acceptDestroy(entity)
        }
      })
    },
    acceptDestroy(entity) {
      this.$vs.loading()
      this.services.deleteTeacher(this.lessonId, entity.id)
        .then(
          data => {
            this.$vs.loading.close()
            this.teachersList = this.teachersList.filter(element => {
              return element.id !== entity.id
            })

            this.notifySuccess(this.$vs)
          },
          error => {
            this.$vs.loading.close()
            this.showErrors(this.$validator, error)
          }
        )
    },
    clearFields() {
      this.teacher.name = null
      this.teacher.email = null
    },
    loadData() {
      this.services.getAllTeachers(this.lessonId).then(
        response => {
          this.teachersList = Array.from(response)
        },
        error => {this.$vs.loading.close()}
      ).finally(() => {this.$vs.loading.close()})
    },
    addTeachersList(list = null) {
      if (list && this._.isArray(list) && list.length > 0) {
        const entityList = []

        list.forEach(
          (entity) => entityList.push(entity)
        )
        this.addTeachers(entityList)
      }
    },
    addTeachers(ids) {
      this.$vs.loading()
      if (this.lessonId) {
        this.services.attachTeachers(this.lessonId, ids).then(
          response => {
            this.notifySuccess(this.$vs, this.$t('messages.success'))
            this.loadData()
          },
          error => {this.notifyError(this.$vs, 'Não foi possível adicionar o(s) professor(es)!')}
        ).finally(() => {this.$vs.loading.close()})
      }
    },
    updateGrid() {
      this.loadData()
    },
    closePopup(show) {
      this.showTeacherPopupSearch = show
    },
  },
  beforeMount() {

  },
  beforeDestroy() {

  },
  mounted() {
    this.loadData()
  }
}
</script>
